import React, { useId, useMemo } from 'react';
import '.././PopupCommonStyle.css';
import styles from './Style.module.css';
import { useGetServiceAddons } from '../../../APICalling/useApiQueries';
import Placeholder from '../../Placeholder/Placeholder';
import CloseCircleIcon from '../../Icons/CloseCircleIcon';
import { Check, Plus } from 'lucide-react';
import { useLocation } from '../../../Context/Location/LocationContext';
import { BtnSecondary } from '../../Buttons/BtnSecondary';
import { getAddonPrice } from '../../../Utils/addonPricing';

export const ServiceAddonPopup = ({
  active,
  handleClick,
  serviceId,
  selectedAddonIds = [],
  onSelectAddon,
}) => {
  const titleId = useId();
  const { selectedOutletID } = useLocation();

  const addonParams = useMemo(() => ({
    service_id: serviceId,
    outlet_id: selectedOutletID,
    status: 1,
  }), [selectedOutletID, serviceId]);

  const { data: addonData } = useGetServiceAddons(addonParams, {
    enabled: active && !!serviceId,
  });

  const addonGroups = addonData?.data?.data || [];
  const serviceAddons = addonGroups.flatMap((item) => item?.addons || []);
  const emptyMessage = addonData?.data?.message || "No add-on related to this service";

  const formatAddonPrice = (price) => {
    const value = Number(price);
    if (!Number.isFinite(value)) return "S$0";
    if (Number.isInteger(value)) return `S$${value}`;
    return `S$${value.toFixed(2)}`;
  };

  // Handle toggle - add or remove addon
  const handleAddonToggle = (addon) => {
    onSelectAddon?.(addon);
    if (serviceAddons.length === 1 && !selectedAddonIds.includes(addon.id)) {
      handleClick?.();
    }
  };

  return (
    <div
      className={`${styles.serviceAddonPopup} popup ${active ? "show" : ""}`}
      role="dialog"
      aria-modal={active ? "true" : undefined}
      aria-labelledby={titleId}
      aria-hidden={!active}
    >
      <div className={`${styles.popHeader} popup-header`}>
        <h2 id={titleId} className="title">Select Add-ons</h2>
        {/* <BtnClose
          handleClick={handleClick}
          title="Close"
          customClass="popup-exit-btn"
        /> */}
      </div>
      <div
        className={`${styles.serviceAddonPopupContent} popup-body ${
          serviceAddons.length > 0 ? "" : styles.emptyBody
        }`}
      >
        {serviceAddons.length > 0 ? (
          serviceAddons.map((addon) => {
            const addonPrice = getAddonPrice(addon);
            return (
              <div key={addon.id} className={styles.addonItem}>
                <div className={styles.addonLeft}>
                  <p className={styles.addonName}>{addon.name}</p>
                </div>
                <div className={styles.addonRight}>
                  <p className={styles.addonPrice}>
                    {formatAddonPrice(addonPrice)}
                  </p>
                  <button
                    type="button"
                    className={`${styles.addButton} btn ${
                      selectedAddonIds.includes(addon.id) ? styles.selected : ""
                    }`}
                    title={
                      selectedAddonIds.includes(addon.id)
                        ? `Remove ${addon.name}`
                        : `Add ${addon.name}`
                    }
                    aria-label={
                      selectedAddonIds.includes(addon.id)
                        ? `Remove ${addon.name}`
                        : `Add ${addon.name}`
                    }
                    onClick={() => handleAddonToggle(addon)}
                  >
                    {selectedAddonIds.includes(addon.id) ? (
                      <Check size={20} color="#fff" />
                    ) : (
                      <Plus size={20} color="var(--PrimaryColor800)" />
                    )}
                  </button>
                </div>
                 
              </div>
            );
          })
        ) : (
          <Placeholder
            heading={emptyMessage}
            para="Please try again later"
            icon={<CloseCircleIcon />}
            customClass={styles.emptyMessage}
          />
        )}
      </div>
       <div className={`${styles.footer} popup-footer`}>
        <BtnSecondary 
        label="Close" 
        handleClick={handleClick} 
        customClass="w-100"
        />
           {/* <button className={styles.closeButton} onClick={handleClick}>
          Close
        </button> */}
        </div>
    </div>
  );
};
